import chatbotRequest from '@/service/channel/http'
import type { OnlineAgentsReq, OnlineAgentsRes } from '../type/getOnlineAgents'

export function getOnlineAgentsApi(data: OnlineAgentsReq): Promise<OnlineAgentsRes> {
    return chatbotRequest<OnlineAgentsRes, OnlineAgentsReq, OnlineAgentsRes>({
        url: '/api/room/online/agents',
        method: 'post',
        data,
    })
}